import React, { createContext, useState, useContext, useEffect } from 'react';
import useSocket from '../hooks/useSocket'
import { useQueryClient } from "@tanstack/react-query";
const TaskContext = createContext();

// Task Item {id,title,description}

export function TaskProvider({ children }) {
    const [tasks, setTasks] = useState([]);
    const { on, off } = useSocket()
    const queryClient = useQueryClient()

    const addTask = (task) => {
        setTasks((prev) => [...prev, task]);
    };

    const removeTask = (task) => {
        setTasks((prev) => [...prev].filter(item => item.id !== task.id));
    }

    const onChangeMode = () => {
        queryClient.invalidateQueries({ queryKey: ['UserData'] })
        removeTask({ id: "ACTIVE_MODE" })
    }
    const onChangePower = () => {
        queryClient.invalidateQueries({ queryKey: ['UserBalance'] })
        removeTask({ id: "INCREASE_POWER" })
    }

    useEffect(() => {
        on('MODE', (mes) => {
            console.log('MODE', mes)
            onChangeMode()
        })
        on('POWER', (mes) => {
            console.log('POWER', mes)
            onChangePower()
        })
        return () => {
            off('MODE', () => {
                onChangeMode()
            })
            off('POWER', () => {
                onChangeMode()
            })
        }
    }, [])

    return (<TaskContext.Provider value={{ tasks, addTask, removeTask }}>
        {children}
    </TaskContext.Provider>
    );
}

export function useTasks() {
    return useContext(TaskContext);
}
